import React, { useState } from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Modaledituser from "./Modaledituser";
import Modaleditpass from "./Modaleditpass";
// import Notifications from "@material-ui/icons/Notifications";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Search from "@material-ui/icons/Search";
// core components
// import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";

import AuthService from "../../services/auth.service";

const user = JSON.parse(sessionStorage.getItem("user"));
// import { usertype } from "../../variables/usertype";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
const useStyles = makeStyles(styles);

// let userType = "";
export default function AdminNavbarLinks() {
  const [show_editpass, setShow_editpass] = useState(false);
  const [show, setShow] = useState(false);
  const classes = useStyles();

  // if (user.user.member_type == 1) {
  //   userType = "ผู้ดูแลระบบ";
  // } else if (user.user.member_type == 2) {
  //   userType = "เจ้าหน้าที่";
  // }
  // console.log(userType);
  // const userType = "เจ้าหน้าที่";

  // const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  // const handleClickNotification = (event) => {
  //   if (openNotification && openNotification.contains(event.target)) {
  //     setOpenNotification(null);
  //   } else {
  //     setOpenNotification(event.currentTarget);
  //   }
  // };
  // const handleCloseNotification = () => {
  //   setOpenNotification(null);
  // };
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
      // setShow(true);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };
  const handleProfile = () => {
    setShow(true);
    setOpenProfile(null);
  };

  const handlePassword = () => {
    setShow_editpass(true);
    setOpenProfile(null);
  };
  const handleLogout = () => {
    AuthService.logout();
    window.location.replace("/");
  };
  return (
    <div>
      <Modaleditpass
        show={show_editpass}
        hidden={setShow_editpass}
        userid={user.user.user_id}
      />
      <Modaledituser show={show} hidden={setShow} userid={user.user.user_id} />
      <div className={classes.manager}>
        <p style={{ display: "inline" }}>
          {user.user.member_type == 2 || user.user.member_type == 3 ? (
            <span>
              {user.user.type_name}
              <span
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  color: "green",
                }}
              >
                {" "}
                {"เขต " + user.user.user_reg}
              </span>{" "}
            </span>
          ) : (
            user.user.type_name
          )}
        </p>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>ข้อมูลทั่วไป</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleProfile}
                      className={classes.dropdownItem}
                    >
                      ข้อมูลทั่วไป
                    </MenuItem>
                    <MenuItem
                      onClick={handlePassword}
                      className={classes.dropdownItem}
                    >
                      เปลี่ยนรหัสผ่าน
                    </MenuItem>
                    <Divider light />
                    <MenuItem
                      onClick={handleLogout}
                      className={classes.dropdownItem}
                    >
                      ออกจากระบบ
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
